
import http from '@/libs/http'

/*
	NOTICE:
	- every action starts with an underscore
*/

const actions: any = {
	//? LOCTATIONS
	async _listLocations({ state, dispatch }: any) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.get(env.apiUrl + `/api/v1/locations/list`, config)
			// // console.log(resp.data);
			// return resp.data
			const resp = await http.getAuth(`/api/v1/locations/list`)
			return resp || []
		} catch (error: any) {
			console.error(error)
			// const msg = error.response?.data?.msg || error.response?.data || error.message

			return []
		}
	},

	async _listLocationsByProject({ state, dispatch }: any, projectId: string) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.get(env.apiUrl + `/api/v1/locations/list/${projectId}`, config)
			// // console.log(resp.data);
			// return resp.data
			const resp = await http.getAuth(`/api/v1/locations/list/${projectId}`)
			return resp || []
		} catch (error: any) {
			console.error(error)
			// const msg = error.response?.data?.msg || error.response?.data || error.message

			return []
		}
	},

	async _getLocations({ state, dispatch }: any, id: string) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.get(env.apiUrl + `/api/v1/locations/${id}`, config)
			// // console.log(resp.data);
			// return resp.data
			const resp = await http.getAuth(`/api/v1/locations/${id}`)
			return resp || {}
		} catch (error: any) {
			console.error(error)
			// const msg = error.response?.data?.msg || error.response?.data || error.message

			return {}
		}
	},

	async _addNewLocation({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.post(env.apiUrl + `/api/v1/locations/add`, data, config)
			// // console.log(resp.data);
			// // µUtils.µ_success(resp.data.msg)
			// await dispatch("_initAdmin", [ 'locations' ])
			// return resp.data

			const resp = await http.postAuth(`/api/v1/locations/add`, data)
			await dispatch('_initAdmin', ['locations'])
			return resp || {}
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message

			throw new Error(msg)

			// return {}
		}
	},

	//? DELETE PROJECTS
	async _deleteLocation({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/locations/delete/${data._id}`, data, config)
			// await dispatch('_initAdmin', ['locations'])
			// return resp.data
			const resp = await http.postAuth(`/api/v1/locations/delete/${data._id}`, data)
			await dispatch('_initAdmin', ['locations'])
			return resp || {}
		} catch (error: any) {
			console.error(error)
			throw new Error(error?.response?.data?.msg || error?.response?.data || 'failed to delete location')
		}
	},

	async _updateLocation({ state, dispatch }: any, data: any) {
		try {
			delete data.sunData
			delete data.weatherData
			// console.log(data)
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/locations/update`, data, config)
			// // console.log(resp.data);
			// // µUtils.µ_success(resp.data.msg)
			// await dispatch('_initAdmin', ['locations'])
			// return resp.data
			const resp = await http.postAuth(`/api/v1/locations/update`, data)
			await dispatch('_initAdmin', ['locations'])
			return resp || {}
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message

			// return {}
			throw new Error(msg)
		}
	},

	//? _archiveLocation PROJECTS
	async _archiveLocation({ state, dispatch }: any, locationId: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/locations/archive/${locationId}`, {}, config)
			// await dispatch('_initAdmin')
			// return resp.data
			const resp = await http.postAuth(`/api/v1/locations/archive/${locationId}`, {})
			await dispatch('_initAdmin', ['locations'])
			return resp || {}
		} catch (error: any) {
			console.error(error)
			throw new Error(error?.response?.data?.msg || error?.response?.data || 'failed to delete location')
		}
	},
}

export default actions
